import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "preview", "slug"]

  connect() {
    this.preview()
  }

  // The slug line slides open once there's a name, using the same
  // grid-template-rows 0fr -> 1fr trick as collapsible_controller.
  preview() {
    const hasName = this.nameTarget.value.trim() !== ""
    this.previewTarget.classList.toggle("grid-rows-[1fr]", hasName)
    this.previewTarget.classList.toggle("grid-rows-[0fr]", !hasName)
    this.slugTarget.textContent = this.nameTarget.value // Build the preview from the name.
      .normalize("NFKD") // Decompose Unicode characters.
      .replace(/\p{M}/gu, "") // Remove accent marks.
      .toLowerCase() // Lowercase letters.
      .replace(/[^a-z0-9]+/g, "_") // Replace other characters with underscores.
      .replace(/^_+|_+$/g, "") // Trim surrounding underscores.
  }
}
